import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import { parseCssString } from '../../utils/utils';

const ImageSlider = ({ header, headerClasses, animate, items, backgroundColor = '#F3F5F6' }) => {
  const slidingItems = React.useMemo(() => {
    if (!animate || !items?.length) return items || [];
    // Each item is ~280px (200px wide + 80px gap). Repeat enough to fill the screen.
    const minItems = Math.ceil(2560 / 280) + 1;
    const copies = Math.max(1, Math.ceil(minItems / items.length));
    const oneSet = Array.from({ length: copies }, () => items).flat();
    return [...oneSet, ...oneSet];
  }, [animate, items]);

  return (
    <div className="text-center lg:text-left px-8 lg:px-0 py-14 md:px-24 lg:py-12 w-full" style={{ backgroundColor }}>
      <h2 className={`text-4xl font-bold text-center mb-10 ${headerClasses}`}>{parse(header)}</h2>
      <div className="overflow-hidden w-full">
        <div
          className={`flex ${animate ? '' : 'flex-wrap justify-center gap-10 lg:flex-nowrap lg:gap-20'}`}
          style={animate ? {
            width: 'max-content',
            animation: 'slide 85s linear infinite',
            willChange: 'transform',
          } : {}}
        >
          {(animate ? slidingItems : items).map((item, index) => (
            <div key={index} className={`flex-shrink-0 w-[200px] flex items-center ${animate ? 'mr-10' : ''}`}>
              <img
                src={item.image.url}
                alt={item.header || `Slide ${(index % items.length) + 1}`}
                className="mb-4 mx-auto max-h-48 object-contain"
                style={parseCssString(item.imageStyles) || {}}
              />
            </div>
          ))}
        </div>
      </div>
      <style>{`
        @keyframes slide {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
      `}</style>
    </div>
  );
};

ImageSlider.propTypes = {
  header: PropTypes.string,
  headerClasses: PropTypes.string,
  animate: PropTypes.bool,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.shape({
        url: PropTypes.string.isRequired
      }).isRequired,
      imageStyles: PropTypes.string,
      header: PropTypes.string,
      headerClasses: PropTypes.string,
      body: PropTypes.string,
    })
  ),
  backgroundColor: PropTypes.string,
};

export default ImageSlider;
